import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

/* Unknown paths still return HTTP 200 from the SPA fallback, so the page marks
 * itself noindex to stop search engines treating it as real content. */
const NotFound = () => {
  useEffect(() => {
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex';
    document.head.appendChild(robots);

    const previousTitle = document.title;
    document.title = 'Page not found | Théotime Perrichet';

    return () => {
      robots.remove();
      document.title = previousTitle;
    };
  }, []);

  return (
    <main style={{ maxWidth: '40rem', margin: '0 auto', padding: '6rem 1.5rem' }}>
      <h1 className="hero-name">Page not found</h1>
      <p className="hero-bio">This page does not exist.</p>
      <p className="hero-bio"><Link to="/">Back to the portfolio</Link></p>
    </main>
  );
};

export default NotFound;
